export class UniversalFilterMessages {
    public static readonly DEFAULT_PLACEHOLDER = 'universal-filter.default-placeholder';
    public static readonly RESET = 'universal-filter.reset';
    public static readonly PAGING = 'universal-filter.paging';
}